// The case editor remembers the last sidebar tool (Suggestions, Redactions,
// ...) and the "Highlight redactions" switch in localStorage. A freshly
// created case should always open on Suggestions with highlighting off, so the
// new-case upload paths call this before navigating.
export const EDITOR_SIDEBAR_STORAGE_KEY = "pnai-editorActiveComponent";
export const REDACTIONS_HIGHLIGHT_STORAGE_KEY = "pnai-redactionsHighlight";
export const EDITOR_NEW_CASE_RESET_EVENT = "pnai:editor-new-case-reset";

export const resetEditorForNewCase = () => {
  try {
    localStorage.setItem(EDITOR_SIDEBAR_STORAGE_KEY, "suggestions");
    localStorage.setItem(REDACTIONS_HIGHLIGHT_STORAGE_KEY, "false");
  } catch {
    // Storage blocked: the event below still covers a mounted editor.
  }
  // The editor shell stays mounted when moving between cases, so tell it directly.
  window.dispatchEvent(new Event(EDITOR_NEW_CASE_RESET_EVENT));
};
